export const LOADING = "Main_LOADING";
export const API_SUCCESS = "Main_API_SUCCESS";
export const API_FAILURE = "Main_API_FAILURE";
export const USER_DATA_LOADED = "Main_USER_DATA_LOADED";
export const INSURRANCE_COMPANIES_LOADING = "Main_INSURRANCE_COMPANIES_LOADING";
export const INSURRANCE_COMPANIES_LOADED = "Main_INSURRANCE_COMPANIES_LOADED";
